var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createEvent, createEffect, guard, sample } from "effector";
import { $playerCurrentTrack, $playerCurrentTrackIndex, $playerPreviousTrack, setPlayerCurrentTrackIndex, setPlayerTrackQueue, $playerCurrentTrackSource, $playerShuffleEnabled } from "frontend/src/domain/player-track-queue";
import { getTimetablePlaylistForToday } from "frontend/src/api/timetables";
import { setTimetableInterruptions } from "frontend/src/features/play-timetable-interruptions";
import { play, resetAudio } from "frontend/src/features/control-audio";
import { state } from 'frontend/src/shared/state';
export var playCurrentTrackInQueueAttempted = createEvent();
export var tryPlayNextTrackInQueue = createEvent();
export var tryPlayPreviousTrackInQueue = createEvent();
export var tryPlayNextTrackInQueueManually = createEvent();
export var tryPlayPreviousTrackInQueueManually = createEvent();
export var reloadPlaylistForPrevNextInTimetable = createEffect(function (params) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (state.currentTimetableId !== -1 && params > 0 && !state.timetableReloading && state.trackSwitchedByUser) {
            state.timetableReloading = true;
            resetAudio();
            setPlayerCurrentTrackIndex(0);
            getTimetablePlaylistForToday(state.currentTimetableId)
                .then(function (response) {
                setTimetableInterruptions(response.interruptions);
                setPlayerTrackQueue({
                    type: "today_timetable",
                    attributes: {
                        id: state.currentTimetableId,
                        title: state.currentTimetableTitle
                    },
                    tracks: response.tracks
                });
                setPlayerCurrentTrackIndex(0);
                play(response.tracks[0].url);
                state.timetableReloading = false;
                state.trackSwitchedByUser = false;
            }).catch(function () {
                state.timetableReloading = false;
                state.trackSwitchedByUser = false;
            });
        }
        return [2 /*return*/, {}];
    });
}); });
var playNextTrackInQueueAttempted = createEvent();
var playPreviousTrackInQueueAttempted = createEvent();
var playTrackByIndexAttempted = createEvent();
guard({
    clock: playCurrentTrackInQueueAttempted,
    source: $playerCurrentTrack.map(function (source) { return source === null || source === void 0 ? void 0 : source.url; }),
    filter: function (url) { return typeof url === 'string'; },
    target: play.prepend(function (url) { return url !== null && url !== void 0 ? url : ""; }),
});
var targetNextTrack = sample({
    clock: tryPlayNextTrackInQueue,
    source: {
        trackSource: $playerCurrentTrackSource,
        currentTrackIndex: $playerCurrentTrackIndex,
        shuffleEnabled: $playerShuffleEnabled,
    },
    filter: function (_a) {
        var _b;
        var trackSource = _a.trackSource;
        return Boolean((_b = trackSource === null || trackSource === void 0 ? void 0 : trackSource.tracks) === null || _b === void 0 ? void 0 : _b.length);
    },
    fn: function (_a) {
        var _b, _c, _d;
        var trackSource = _a.trackSource, currentTrackIndex = _a.currentTrackIndex, shuffleEnabled = _a.shuffleEnabled;
        var tracks = (_b = trackSource === null || trackSource === void 0 ? void 0 : trackSource.tracks) !== null && _b !== void 0 ? _b : [];
        var tracksCount = tracks.length;
        if (tracksCount === 0) {
            return { index: currentTrackIndex, url: "" };
        }
        if (shuffleEnabled && tracksCount > 1) {
            var nextIndex_1 = Math.floor(Math.random() * tracksCount);
            var index_1 = nextIndex_1 === currentTrackIndex ? (nextIndex_1 + 1) % tracksCount : nextIndex_1;
            return { index: index_1, url: tracks[index_1].url };
        }
        var nextIndex = currentTrackIndex + 1;
        var index = nextIndex < tracksCount
            ? nextIndex
            : (trackSource === null || trackSource === void 0 ? void 0 : trackSource.type) === "playlist"
                ? 0
                : currentTrackIndex;
        return { index: index, url: (_d = (_c = tracks[index]) === null || _c === void 0 ? void 0 : _c.url) !== null && _d !== void 0 ? _d : "" };
    },
    target: playTrackByIndexAttempted,
});
guard({
    clock: tryPlayPreviousTrackInQueue,
    source: $playerPreviousTrack,
    filter: function (track) { return !!track; },
    target: playPreviousTrackInQueueAttempted,
});
sample({
    clock: playTrackByIndexAttempted,
    fn: function (_a) {
        var index = _a.index;
        return index;
    },
    target: setPlayerCurrentTrackIndex,
});
sample({
    clock: playTrackByIndexAttempted,
    fn: function (_a) {
        var url = _a.url;
        return url;
    },
    filter: function (_a) {
        var url = _a.url;
        return typeof url === "string" && url.length > 0;
    },
    target: play,
});
sample({
    clock: targetNextTrack,
    source: $playerCurrentTrackSource,
    filter: function (trackSource) { return (trackSource === null || trackSource === void 0 ? void 0 : trackSource.type) === "today_timetable"; },
    fn: function (_, _a) {
        var index = _a.index;
        return index;
    },
    target: reloadPlaylistForPrevNextInTimetable,
});
var targetPrevTrack = sample({
    clock: playPreviousTrackInQueueAttempted,
    source: $playerCurrentTrackIndex,
    fn: function (index) { return index - 1; },
    target: [setPlayerCurrentTrackIndex, playCurrentTrackInQueueAttempted],
});
